import React from "react";
import { Button, Col, DatePicker, Form, Input, Radio, Row, Select, Typography } from "antd";
import moment from "moment";

import { mobileNumberValidation, passwordValidation } from "../../utils/Validations";
import { gender } from "../../utils/Constants";

const UpdateFreeUser = () => {
  const [form] = Form.useForm();

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  const onCreateFreeUser = (value) => {
    console.log(value);
  };
  return (
    <div>
      <div className="center">
        <Typography.Title level={2}>Update Account Information</Typography.Title>
      </div>
      <Form onFinish={onCreateFreeUser} form={form} layout="vertical" scrollToFirstError initialValues={{ gender: "male" }}>
        <Row gutter={[8, 8]} className="container">
          <Col xs={24} md={12}>
            <Form.Item name="firstName" label="First Name" rules={[{ required: true, message: "This field is required" }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="lastName" label="Last Name" rules={[{ required: true, message: "This field is required" }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="email" label="Email" rules={[{ required: true, message: "This field is required"}, {type: "email", message: "Email is not valid" }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="phoneNumber" label="Phone Number" rules={[{ required: true, message: "This field is required"}, {pattern: mobileNumberValidation, message: "Number is not valid" }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="dob" label="Date of Birth" rules={[{ required: true, message: "This field is required" }]}>
              <DatePicker style={{ width: "100%" }} disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="gender" label="Gender" rules={[{ required: true, message: "This field is required" }]}>
              <Radio.Group buttonStyle="solid">
                {gender.map((el) => (
                  <Radio.Button value={el.value} key={el.value}>
                    {el.name}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="residency" label="Residency" rules={[{ required: true, message: "This field is required" }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="medicalSchool" label="Medical School" rules={[{ required: true, message: "This field is required" }]}>
              <Select>
                <Select.Option></Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="country" label="Country" rules={[{ required: true, message: "This field is required" }]}>
              <Select>
                <Select.Option></Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="state" label="State" rules={[{ required: true, message: "This field is required" }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: "This field is required"}, {pattern: passwordValidation, message: "Must have number, special character, uppercase. Minimum 8 length" }]}>
              <Input.Password />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="confirmPassword"
              label="Confirm Password"
              dependencies={["password"]}
              rules={[
                { required: true, message: "This field is required" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("The two passwords that you entered do not match!"));
                  },
                }),
              ]}>
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
        <div className="center mt-2">
          <Button type="primary" htmlType="submit">
            Update User Account
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default UpdateFreeUser;
